import React from "react";
import ActionsCog from "../shared/general/ActionsCog";
import {
  Wrapper,
  JobInfo,
  JobTitle,
  JobLocation,
  JobActions,
} from "./styles/job-styles";
import Application from "../../apiResources/Application";

const JobApplicationDetails = (props: Props) => {
  const { application } = props;
  const { engagement } = application;
  const { job } = engagement;

  const cogActions = [
    {
      name: "Withdraw",
      id: 2,
      clickAction: () => {
        const withdrawPath = `/recruiter/jobs/${job.id}/engagements/${engagement.id}/applications/${application.id}/remove?redirect=candidate`;
        window.location.href = withdrawPath;
      },
    },
    {
      name: "Application Summary",
      id: 3,
      clickAction: () => {
        const summaryPath = `/recruiter/jobs/${job.id}/engagements/${engagement.id}/applications/${application.id}#/information`;
        window.location.href = summaryPath;
      },
    },
  ];

  return (
    <Wrapper key={job.id}>
      <JobInfo>
        <JobTitle className="jobTitle">{job.title}</JobTitle>
        <JobLocation className="location">{job.location}</JobLocation>
      </JobInfo>
      <JobActions>
        <ActionsCog actions={cogActions} />
      </JobActions>
    </Wrapper>
  );
};

type Props = {
  application: Application;
};

export default JobApplicationDetails;
